/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tracking_Stop_Location_UnknownInputs */

const vi_tracking_stop_location_unknown = /** @type {(inputs: Tracking_Stop_Location_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không xác định được vị trí điểm dừng.`)
};

/**

* @param {Tracking_Stop_Location_UnknownInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tracking_stop_location_unknown = /** @type {((inputs?: Tracking_Stop_Location_UnknownInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tracking_Stop_Location_UnknownInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tracking_stop_location_unknown(inputs)
});